interface CategoryTabsProps {
  categories: { id: string; name: string; icon: string }[];
  activeCategory: string;
  onSelect: (id: string) => void;
}

export default function CategoryTabs({ categories, activeCategory, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => (
        <button
          key={cat.id}
          onClick={() => onSelect(cat.id)}
          className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
            activeCategory === cat.id
              ? "bg-primary-500 text-white"
              : "bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900"
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}